/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  ErrorDescription,
  GetProductsParams,
  ProductGroupDoctorApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * ## Example WeightLoss Response
```
[
    {
        "Group": "Semaglutide",
        "IsPharmacyPickupAllowed": false,
        "Products": [
            {
                "ProductId": "0f282e69-10bd-4407-a70f-b6f654aee3c1",
                "Name": "Semaglutide",
                "Brand": "Wegovy",
                "Variation": "Branded",
                "Duration": "1 month",
                "Restriction": null,
                "IsPharmacyPickupAllowed": false,
                "PriceRange": {
                    "From": 769,
                    "To": 769
                },
                "Options": [
                    {
                        "OptionId": "wg_0.25mg:qw:2ml:28:0.25mg",
                        "Name": "0.25 mg weekly x4 weeks",
                        "ShortName": "0.25mg",
                        "Price": 769,
                        "DurationDisplay": "weekly x4 weeks",
                        "IsRefillAllowed": false,
                        "PharmacyPartner": "Monark",
                        "DispenseUnits": "ml",
                        "DrugOptions": []
                    },
                    {
                        "OptionId": "wg_0.5mg:qw:2ml:28:0.5mg",
                        "Name": "0.5 mg weekly x4 weeks",
                        "ShortName": "0.5mg",
                        "Price": 769,
                        "DurationDisplay": "weekly x4 weeks",
                        "IsRefillAllowed": true,
                        "PharmacyPartner": "Monark",
                        "DispenseUnits": "ml",
                        "DrugOptions": []
                    }
                ],
                "Cohorts": []
            }
        ]
    }
]
            
```
            
## Example MOUD Response
```
[
    {
        "Group": "Buprenorphine / Naloxone",
        "Products": [
            {
                "ProductId": "48dd8c81-658e-1faf-8d3b-709be1ef9a09",
                "Name": "Buprenorphine / Naloxone",
                "Brand": "Branded (Zubsolv)",
                "Variation": "Branded (Zubsolv)",
                "Duration": "1 week - 1 month",
                "Restriction": null,
                "IsPharmacyPickupAllowed": true,
                "IsProviderOverridesEnabled": true,
                "PriceRange": {
                    "From": 0,
                    "To": 0
                },
                "Options": [
                    {
                        "OptionId": "brand:zubsolv:11.4-2.9mgsltablet",
                        "Name": "11.4-2.9MG SL Tablet",
                        "ShortName": "11.4-2.9MG",
                        "Price": 0,
                        "DurationDisplay": "Sublingual Tablets",
                        "IsRefillAllowed": false,
                        "PharmacyPartner": "PharmacyPickup",
                        "DispenseUnits": "tablet",
                        "DrugOptions": [
                            {
                                "DrugOptionId": "9eaea5ca-5d28-4711-bd7f-023fdd34b80e",
                                "DrugOption": "1 tablet daily",
                                "Quantity": 1
                            },
                            {
                                "DrugOptionId": "b5237cc7-97ee-18ef-ad89-9207f5ef37fd",
                                "DrugOption": "1.5 tablets daily",
                                "Quantity": 1.5
                            },
                            {
                                "DrugOptionId": "c8e0afa7-5c02-3a46-a27c-4d98f1346a9d",
                                "DrugOption": "2 tablets daily",
                                "Quantity": 2
                            }
                        ]
                    }
                ],
                "Cohorts": [
                    "honeybee"
                ]
            }
        ]
    }
]
```
# Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 401 |  | Authentication failed |
| 404 | PatientNotFound | |
| 500 | InternalServerError | Internal server error |
 */
export const getProducts = (
    params?: GetProductsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ProductGroupDoctorApiOutContract[]>(
      {url: `https://providers-api.api.quick.md/api/v1/products`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetProductsInfiniteQueryKey = (params?: GetProductsParams,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/products`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetProductsQueryKey = (params?: GetProductsParams,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/products`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetProductsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(params?: GetProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params: undefined |  GetProductsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetProductsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProductsInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetProductsQueryOptions = <TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params: undefined |  GetProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetProductsQuery = async <TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProductsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetProductsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(params?: GetProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsSuspenseQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetProductsSuspense<TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params: undefined |  GetProductsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsSuspense<TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsSuspense<TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductsSuspense<TData = Awaited<ReturnType<typeof getProducts>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProductsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(params?: GetProductsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsSuspenseInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetProductsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params: undefined |  GetProductsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 params?: GetProductsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




